// Calendar-day helpers. Every date in this feature is a `YYYY-MM-DD` string —
// the API's own format, and the client's local day. Arithmetic goes through
// UTC midnight so a DST change never moves a day.

export const DAY_MS = 864e5;

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const MONTH_LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const WEEKDAY_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const WEEKDAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** `YYYY-MM-DD` → UTC ms. */
export const toMs = (iso) => Date.parse(`${iso}T00:00:00Z`);

/** UTC ms → `YYYY-MM-DD`. */
export const toIso = (ms) => new Date(ms).toISOString().slice(0, 10);

export const addDays = (iso, n) => toIso(toMs(iso) + n * DAY_MS);

/** Whole days from `a` to `b` (b − a). */
export const daysBetween = (a, b) => Math.round((toMs(b) - toMs(a)) / DAY_MS);

/** The browser's local calendar day. */
export function localToday(now = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}

/** `iso` moved back by `months` calendar months (day clamped by Date). */
export function minusMonths(iso, months) {
  const d = new Date(toMs(iso));
  d.setUTCMonth(d.getUTCMonth() - months);
  return toIso(d.getTime());
}

/** "Sep 22" */
export const fm = (iso) => {
  const d = new Date(toMs(iso));
  return `${MON[d.getUTCMonth()]} ${d.getUTCDate()}`;
};

/** "Sep 22, 2026" */
export const fmy = (iso) => `${fm(iso)}, ${new Date(toMs(iso)).getUTCFullYear()}`;

/** "Sep 22–26" within a month, "Sep 29–Oct 3" across months. */
export const fr = (a, b) => {
  const x = new Date(toMs(a));
  const y = new Date(toMs(b));
  return x.getUTCMonth() === y.getUTCMonth() ? `${fm(a)}–${y.getUTCDate()}` : `${fm(a)}–${fm(b)}`;
};

/** "Tuesday, Oct 13, 2026" */
export const longDate = (iso) => `${WEEKDAY_LONG[new Date(toMs(iso)).getUTCDay()]}, ${fmy(iso)}`;

/** "Tue, Oct 13, 2026" */
export const shortWeekdayDate = (iso) => `${WEEKDAY_SHORT[new Date(toMs(iso)).getUTCDay()]}, ${fmy(iso)}`;

/** `{ year, month }` (month 0-based) of a date. */
export const monthOf = (iso) => {
  const d = new Date(toMs(iso));
  return { year: d.getUTCFullYear(), month: d.getUTCMonth() };
};

/** Month index counted from year 0, for comparing and stepping months. */
export const monthIndex = ({ year, month }) => year * 12 + month;
export const fromMonthIndex = (i) => ({ year: Math.floor(i / 12), month: i % 12 });
